import { themeGet } from "@styled-system/theme-get";
import type { IconState, LinkKind } from "./types";
import type { Theme } from "@mos-cat/ds-theme";

export function getIconDataImg(kind: LinkKind, color: IconState, theme: Theme) {
  const colors = {
    default: themeGet("colors.linkColor")({ theme }) as string,
    hover: themeGet("colors.linkHoverColor")({ theme }) as string,
    active: themeGet("colors.linkActiveColor")({ theme }) as string,
  };

  const externalSvg = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.25em"
    height="1.25em"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill="${colors[color]}"
      d="M24.9819 5.25025L20 5.25024V2.75024L28 2.75025C28.6904 2.75025 29.25 3.30989 29.25 4.00025V12.0002H26.75V7.01772L15.884 17.884L14.1162 16.1162L24.9819 5.25025Z"
    />
    <path
      fill="${colors[color]}"
      d="M2.75 7C2.75 6.30964 3.30964 5.75 4 5.75H12V8.25H5.25V26.7504H23.75V20.0001H26.25V28.0004C26.25 28.6907 25.6904 29.2504 25 29.2504H4C3.30964 29.2504 2.75 28.6907 2.75 28.0004V7Z"
    />
  </svg>`;

  const anchorSvg = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.25em"
    height="1.25em"
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill="${colors[color]}"
      d="M26.3209 4.87786C23.56 2.11685 19.0977 2.0091 16.3551 4.75174L13.5803 7.5265L15.3481 9.29426L18.1228 6.5195C19.8383 4.80406 22.7168 4.80926 24.5532 6.64562C26.3895 8.482 26.3947 11.3606 24.6793 13.076L20.6433 17.1121C18.9279 18.8275 16.0493 18.8223 14.213 16.9859L12.4452 18.7537C15.2062 21.5147 19.6685 21.6225 22.4111 18.8798L26.4471 14.8438C29.1897 12.1012 29.0819 7.63888 26.3209 4.87786Z"
    />
    <path
      fill="${colors[color]}"
      d="M10.555 14.0871C12.2704 12.3717 15.149 12.3769 16.9853 14.2133L18.7531 12.4455C15.9921 9.68447 11.5298 9.57673 8.78723 12.3194L4.75123 16.3554C2.00862 19.098 2.11636 23.5603 4.87736 26.3213C7.63835 29.0823 12.1006 29.1901 14.8432 26.4474L17.618 23.6727L15.8502 21.9049L13.0755 24.6797C11.3601 26.3951 8.48148 26.3899 6.64513 24.5536C4.80877 22.7172 4.80358 19.8386 6.519 18.1231L10.555 14.0871Z"
    />
  </svg>`;

  const svgIcon = kind === "anchor" ? anchorSvg : externalSvg;

  return `url('data:image/svg+xml, ${encodeURIComponent(svgIcon)}')`;
}
